import type { ProductCatalogData, SaleRequestTemplateData } from '@/api/kubik/monolith'

export const isOutputsOffer = (product: ProductCatalogData | SaleRequestTemplateData): product is SaleRequestTemplateData =>
  'qualityIndicators' in product
